export default {
    'ERROR-GET-SUPPORT-ADMIN': {
        'RELATION-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: 'Relation introuvable pour trouver votre contact.',
                en: 'Relation not found to retrieve your contact.',
            },
        },
        'NO-USER-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Utilisateur introuvable pour trouver votre contact.",
                en: 'User not found to retrieve your contact.',
            },
        },
        'NO-ADMIN-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Aucun administrateur trouvé pour vous aider pour l'instant.",
                en: 'No administrator found to assist you at the moment.',
            },
        },
    },
    'ERROR-POST-MESSAGE-SUPPORT': {
        'NO-ADMIN-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Administrateur introuvable pour envoyer votre message.",
                en: 'Administrator not found to send your message.',
            },
        },
        'NO-USER-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Utilisateur introuvable pour envoyer votre message.",
                en: 'User not found to send your message.',
            },
        },
    },
};
